// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { MvpApiListCompaniesData, MvpApiListCompaniesResponses, MvpApiGetCompanyData, MvpApiGetCompanyResponses, MvpApiListStoresData, MvpApiListStoresResponses, MvpApiGetStoreData, MvpApiGetStoreResponses, MvpApiListDevicesData, MvpApiListDevicesResponses, MvpApiCreateDeviceData, MvpApiCreateDeviceResponses, MvpApiUpdateDeviceData, MvpApiUpdateDeviceResponses, MvpApiListDevicePingsData, MvpApiListDevicePingsResponses, MvpApiCheckDeviceValidityData, MvpApiCheckDeviceValidityResponses, MvpApiListChargersData, MvpApiListChargersResponses, MvpApiCreateChargerData, MvpApiCreateChargerResponses, MvpApiUpdateChargerData, MvpApiUpdateChargerResponses, MvpApiListVideoCapturesData, MvpApiListVideoCapturesResponses, MvpApiListVideosData, MvpApiListVideosResponses, MvpApiCreateVideoData, MvpApiCreateVideoResponses, MvpApiGetVideoData, MvpApiGetVideoResponses, MvpApiUpdateVideoTagsData, MvpApiUpdateVideoTagsResponses, MvpApiListVideoExportsData, MvpApiListVideoExportsResponses, MvpApiCreateVideoExportRequestData, MvpApiCreateVideoExportRequestResponses, MvpApiGetVideoExportRequestData, MvpApiGetVideoExportRequestResponses, MvpApiRegisterVideoImagesData, MvpApiRegisterVideoImagesResponses, MvpApiListVideoTagNamesData, MvpApiListVideoTagNamesResponses, MvpApiCreateVideoTagNameData, MvpApiCreateVideoTagNameResponses, MvpApiGetVideoTagNameData, MvpApiGetVideoTagNameResponses, MvpApiUpdateVideoTagNameData, MvpApiUpdateVideoTagNameResponses, MvpApiListVideoTimeTagsData, MvpApiListVideoTimeTagsResponses, MvpApiCreateVideoTimeTagData, MvpApiCreateVideoTimeTagResponses, MvpApiDeleteVideoTimeTagData, MvpApiDeleteVideoTimeTagResponses, MvpApiGetVideoTimeTagData, MvpApiGetVideoTimeTagResponses, MvpApiGetVideoTagsForStoreData, MvpApiGetVideoTagsForStoreResponses, MvpApiUpdateVideoStatusData, MvpApiUpdateVideoStatusResponses, MvpApiUpdateVideoPropertyDataData, MvpApiUpdateVideoPropertyDataResponses, MvpApiGetImageUrlsData, MvpApiGetImageUrlsResponses, MvpApiGetImageGalleryUrlsData, MvpApiGetImageGalleryUrlsResponses, MvpApiGetSingleImageUrlsData, MvpApiGetSingleImageUrlsResponses, MvpApiGetSignedImageUrlData, MvpApiGetSignedImageUrlResponses, MvpApiGetImageRotationData, MvpApiGetImageRotationResponses, MvpApiListJobsData, MvpApiListJobsResponses, MvpApiCreateJobData, MvpApiCreateJobResponses, MvpApiListJobsInFlightData, MvpApiListJobsInFlightResponses, MvpApiListVideoJobsData, MvpApiListVideoJobsResponses, MvpApiGetJobData, MvpApiGetJobResponses, MvpApiUpdateJobData, MvpApiUpdateJobResponses, MvpApiGetJobLogTailData, MvpApiGetJobLogTailResponses, MvpApiGetJobFileData, MvpApiGetJobFileResponses, MvpApiUpdateJobStageData, MvpApiUpdateJobStageResponses, MvpApiMarkStartedJobData, MvpApiMarkStartedJobResponses, MvpApiCompleteJobData, MvpApiCompleteJobResponses, MvpApiErrorOutJobData, MvpApiErrorOutJobResponses, MvpApiStopJobData, MvpApiStopJobResponses, MvpApiRegisterImagesData, MvpApiRegisterImagesResponses, MvpApiListJobTasksData, MvpApiListJobTasksResponses, MvpApiCreateJobTasksData, MvpApiCreateJobTasksResponses, MvpApiGetJobTaskData, MvpApiGetJobTaskResponses, MvpApiCompleteJobTaskData, MvpApiCompleteJobTaskResponses, MvpApiSkipJobTaskData, MvpApiSkipJobTaskResponses, MvpApiGetNextPendingJobTaskData, MvpApiGetNextPendingJobTaskResponses, MvpApiListAllJobTasksData, MvpApiListAllJobTasksResponses, MvpApiTaskActivityData, MvpApiTaskActivityResponses, MvpApiCreateReviewTasksData, MvpApiCreateReviewTasksResponses, MvpApiListToolWebsitesData, MvpApiListToolWebsitesResponses, MvpApiShouldShowStaffToolData, MvpApiShouldShowStaffToolResponses, MvpApiListOosParcelsData, MvpApiListOosParcelsResponses, MvpApiGetOosParcelData, MvpApiGetOosParcelResponses, MvpApiListOosEventBufferData, MvpApiListOosEventBufferResponses, MvpApiGetOosEventFromBufferData, MvpApiGetOosEventFromBufferResponses, MvpApiListOosEventBatchesData, MvpApiListOosEventBatchesResponses, MvpApiGetOosEventBatchData, MvpApiGetOosEventBatchResponses, MvpApiListPlanogramsData, MvpApiListPlanogramsResponses, MvpApiCreatePlanogramData, MvpApiCreatePlanogramResponses, MvpApiGetPlanogramData, MvpApiGetPlanogramResponses, MvpApiGetPlanogramLabelData, MvpApiGetPlanogramLabelResponses, MvpApiUpdatePlanogramLabelData, MvpApiUpdatePlanogramLabelResponses, MvpApiListPlanogramImagesData, MvpApiListPlanogramImagesResponses, MvpApiCreatePlanogramImagesData, MvpApiCreatePlanogramImagesResponses, MvpApiGetPlanogramImageData, MvpApiGetPlanogramImageResponses, MvpApiGetStoresInventoryData, MvpApiGetStoresInventoryResponses, MvpApiGetDevicesInventoryData, MvpApiGetDevicesInventoryResponses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List Companies
 */
export const mvpApiListCompanies = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListCompaniesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListCompaniesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/companies',
        ...options
    });
};

/**
 * Get Company
 */
export const mvpApiGetCompany = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetCompanyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetCompanyResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/companies/{company_id}',
        ...options
    });
};

/**
 * List Stores
 */
export const mvpApiListStores = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListStoresResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/stores',
        ...options
    });
};

/**
 * Get Store
 */
export const mvpApiGetStore = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetStoreResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/stores/{store_id}',
        ...options
    });
};

/**
 * List Devices
 */
export const mvpApiListDevices = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListDevicesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListDevicesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/devices',
        ...options
    });
};

/**
 * Create Device
 */
export const mvpApiCreateDevice = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateDeviceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateDeviceResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/devices',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Device
 */
export const mvpApiUpdateDevice = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateDeviceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiUpdateDeviceResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/devices/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Device Pings
 */
export const mvpApiListDevicePings = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListDevicePingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListDevicePingsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/devices/pings',
        ...options
    });
};

/**
 * Check Device Validity
 */
export const mvpApiCheckDeviceValidity = <ThrowOnError extends boolean = false>(options: Options<MvpApiCheckDeviceValidityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiCheckDeviceValidityResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/device-check/{serial_number}',
        ...options
    });
};

/**
 * List Chargers
 */
export const mvpApiListChargers = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListChargersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListChargersResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/chargers',
        ...options
    });
};

/**
 * Create Charger
 */
export const mvpApiCreateCharger = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateChargerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateChargerResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/chargers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Charger
 */
export const mvpApiUpdateCharger = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateChargerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiUpdateChargerResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/chargers/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Video Captures
 */
export const mvpApiListVideoCaptures = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListVideoCapturesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListVideoCapturesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-captures',
        ...options
    });
};

/**
 * List Videos
 */
export const mvpApiListVideos = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListVideosData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListVideosResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/videos',
        ...options
    });
};

/**
 * Create Video
 */
export const mvpApiCreateVideo = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateVideoData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateVideoResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/videos',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Video
 */
export const mvpApiGetVideo = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetVideoData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetVideoResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/videos/{video_id}',
        ...options
    });
};

/**
 * Update Video Tags
 */
export const mvpApiUpdateVideoTags = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateVideoTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<MvpApiUpdateVideoTagsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/videos/{video_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Video Exports
 */
export const mvpApiListVideoExports = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListVideoExportsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListVideoExportsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-export-requests',
        ...options
    });
};

/**
 * Create Video Export Request
 */
export const mvpApiCreateVideoExportRequest = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateVideoExportRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateVideoExportRequestResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-export-requests',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Video Export Request
 */
export const mvpApiGetVideoExportRequest = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetVideoExportRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetVideoExportRequestResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-export-requests/{export_id}',
        ...options
    });
};

/**
 * Register Video Images
 */
export const mvpApiRegisterVideoImages = <ThrowOnError extends boolean = false>(options: Options<MvpApiRegisterVideoImagesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiRegisterVideoImagesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/videos/{video_id}/register-images',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Video Tag Names
 */
export const mvpApiListVideoTagNames = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListVideoTagNamesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListVideoTagNamesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-tag-names',
        ...options
    });
};

/**
 * Create Video Tag Name
 */
export const mvpApiCreateVideoTagName = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateVideoTagNameData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateVideoTagNameResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-tag-names',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Video Tag Name
 */
export const mvpApiGetVideoTagName = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetVideoTagNameData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetVideoTagNameResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-tag-names/{tag_name_id}',
        ...options
    });
};

/**
 * Update Video Tag Name
 */
export const mvpApiUpdateVideoTagName = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateVideoTagNameData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<MvpApiUpdateVideoTagNameResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-tag-names/{tag_name_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Video Time Tags
 */
export const mvpApiListVideoTimeTags = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListVideoTimeTagsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListVideoTimeTagsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-time-tags',
        ...options
    });
};

/**
 * Create Video Time Tag
 */
export const mvpApiCreateVideoTimeTag = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateVideoTimeTagData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateVideoTimeTagResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-time-tags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Video Time Tag
 */
export const mvpApiDeleteVideoTimeTag = <ThrowOnError extends boolean = false>(options: Options<MvpApiDeleteVideoTimeTagData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<MvpApiDeleteVideoTimeTagResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-time-tags/{time_tag_id}',
        ...options
    });
};

/**
 * Get Video Time Tag
 */
export const mvpApiGetVideoTimeTag = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetVideoTimeTagData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetVideoTimeTagResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-time-tags/{time_tag_id}',
        ...options
    });
};

/**
 * Get Video Tags For Store
 */
export const mvpApiGetVideoTagsForStore = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetVideoTagsForStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetVideoTagsForStoreResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-tags/{store_id}',
        ...options
    });
};

/**
 * Update Video Status
 */
export const mvpApiUpdateVideoStatus = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateVideoStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiUpdateVideoStatusResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-status/{video_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Video Property Data
 */
export const mvpApiUpdateVideoPropertyData = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateVideoPropertyDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiUpdateVideoPropertyDataResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-metadata/{video_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Image Urls
 */
export const mvpApiGetImageUrls = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetImageUrlsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiGetImageUrlsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/images',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Image Gallery Urls
 */
export const mvpApiGetImageGalleryUrls = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetImageGalleryUrlsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiGetImageGalleryUrlsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/images/gallery',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Single Image Urls
 */
export const mvpApiGetSingleImageUrls = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetSingleImageUrlsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetSingleImageUrlsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/images/{image_id}',
        ...options
    });
};

/**
 * Get Signed Image Url
 */
export const mvpApiGetSignedImageUrl = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetSignedImageUrlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetSignedImageUrlResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/images/{image_id}/signed',
        ...options
    });
};

/**
 * Get Image Rotation
 */
export const mvpApiGetImageRotation = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetImageRotationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetImageRotationResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/images/{image_id}/rotation',
        ...options
    });
};

/**
 * List Jobs
 */
export const mvpApiListJobs = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListJobsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListJobsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs',
        ...options
    });
};

/**
 * Create Job
 */
export const mvpApiCreateJob = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateJobData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateJobResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Jobs In Flight
 */
export const mvpApiListJobsInFlight = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListJobsInFlightData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListJobsInFlightResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs-in-flight',
        ...options
    });
};

/**
 * List Video Jobs
 */
export const mvpApiListVideoJobs = <ThrowOnError extends boolean = false>(options: Options<MvpApiListVideoJobsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiListVideoJobsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/video-jobs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Job
 */
export const mvpApiGetJob = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetJobData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetJobResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}',
        ...options
    });
};

/**
 * Update Job
 */
export const mvpApiUpdateJob = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateJobData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<MvpApiUpdateJobResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Job Log Tail
 */
export const mvpApiGetJobLogTail = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetJobLogTailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetJobLogTailResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}/log-tail',
        ...options
    });
};

/**
 * Get Job File
 */
export const mvpApiGetJobFile = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetJobFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetJobFileResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}/file/{filename}',
        ...options
    });
};

/**
 * Update Job Stage
 */
export const mvpApiUpdateJobStage = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateJobStageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiUpdateJobStageResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}/update-stage',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mark Started Job
 */
export const mvpApiMarkStartedJob = <ThrowOnError extends boolean = false>(options: Options<MvpApiMarkStartedJobData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiMarkStartedJobResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}/started',
        ...options
    });
};

/**
 * Complete Job
 */
export const mvpApiCompleteJob = <ThrowOnError extends boolean = false>(options: Options<MvpApiCompleteJobData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCompleteJobResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}/complete',
        ...options
    });
};

/**
 * Error Out Job
 */
export const mvpApiErrorOutJob = <ThrowOnError extends boolean = false>(options: Options<MvpApiErrorOutJobData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiErrorOutJobResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}/error',
        ...options
    });
};

/**
 * Stop Job
 */
export const mvpApiStopJob = <ThrowOnError extends boolean = false>(options: Options<MvpApiStopJobData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiStopJobResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}/stop',
        ...options
    });
};

/**
 * Register Images
 */
export const mvpApiRegisterImages = <ThrowOnError extends boolean = false>(options: Options<MvpApiRegisterImagesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiRegisterImagesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}/register-images',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Job Tasks
 */
export const mvpApiListJobTasks = <ThrowOnError extends boolean = false>(options: Options<MvpApiListJobTasksData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiListJobTasksResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}/tasks',
        ...options
    });
};

/**
 * Create Job Tasks
 */
export const mvpApiCreateJobTasks = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateJobTasksData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateJobTasksResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}/tasks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Job Task
 */
export const mvpApiGetJobTask = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetJobTaskData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetJobTaskResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}/tasks/{task_id}',
        ...options
    });
};

/**
 * Complete Job Task
 */
export const mvpApiCompleteJobTask = <ThrowOnError extends boolean = false>(options: Options<MvpApiCompleteJobTaskData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<MvpApiCompleteJobTaskResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}/tasks/{task_id}/complete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Skip Job Task
 */
export const mvpApiSkipJobTask = <ThrowOnError extends boolean = false>(options: Options<MvpApiSkipJobTaskData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<MvpApiSkipJobTaskResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}/tasks/{task_id}/skip',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Next Pending Job Task
 */
export const mvpApiGetNextPendingJobTask = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetNextPendingJobTaskData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetNextPendingJobTaskResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/jobs/{job_id}/next-pending-task',
        ...options
    });
};

/**
 * List All Job Tasks
 */
export const mvpApiListAllJobTasks = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListAllJobTasksData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListAllJobTasksResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/job-tasks',
        ...options
    });
};

/**
 * Task Activity
 */
export const mvpApiTaskActivity = <ThrowOnError extends boolean = false>(options: Options<MvpApiTaskActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiTaskActivityResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/tasks/{task_id}/activity',
        ...options
    });
};

/**
 * Create Review Tasks
 */
export const mvpApiCreateReviewTasks = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateReviewTasksData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateReviewTasksResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/review-tasks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Tool Websites
 */
export const mvpApiListToolWebsites = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListToolWebsitesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListToolWebsitesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/tool-websites',
        ...options
    });
};

/**
 * Should Show Staff Tool
 */
export const mvpApiShouldShowStaffTool = <ThrowOnError extends boolean = false>(options?: Options<MvpApiShouldShowStaffToolData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiShouldShowStaffToolResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/should-show-staff-tool',
        ...options
    });
};

/**
 * List Oos Parcels
 */
export const mvpApiListOosParcels = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListOosParcelsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListOosParcelsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/oos-parcels',
        ...options
    });
};

/**
 * Get Oos Parcel
 */
export const mvpApiGetOosParcel = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetOosParcelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetOosParcelResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/oos-parcels/{parcel_id}',
        ...options
    });
};

/**
 * List Oos Event Buffer
 */
export const mvpApiListOosEventBuffer = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListOosEventBufferData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListOosEventBufferResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/oos-event-buffer',
        ...options
    });
};

/**
 * Get Oos Event From Buffer
 */
export const mvpApiGetOosEventFromBuffer = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetOosEventFromBufferData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetOosEventFromBufferResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/oos-event-buffer/{event_id}',
        ...options
    });
};

/**
 * List Oos Event Batches
 */
export const mvpApiListOosEventBatches = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListOosEventBatchesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListOosEventBatchesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/oos-event-batches',
        ...options
    });
};

/**
 * Get Oos Event Batch
 */
export const mvpApiGetOosEventBatch = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetOosEventBatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetOosEventBatchResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/oos-event-batches/{batch_id}',
        ...options
    });
};

/**
 * List Planograms
 */
export const mvpApiListPlanograms = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListPlanogramsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListPlanogramsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/planograms',
        ...options
    });
};

/**
 * Create Planogram
 */
export const mvpApiCreatePlanogram = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreatePlanogramData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreatePlanogramResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/planograms',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Planogram
 */
export const mvpApiGetPlanogram = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetPlanogramData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetPlanogramResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/planograms/{planogram_id}',
        ...options
    });
};

/**
 * Get Planogram Label
 */
export const mvpApiGetPlanogramLabel = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetPlanogramLabelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetPlanogramLabelResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/planograms/{planogram_id}/labels/{label_uuid}',
        ...options
    });
};

/**
 * Update Planogram Label
 */
export const mvpApiUpdatePlanogramLabel = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdatePlanogramLabelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<MvpApiUpdatePlanogramLabelResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/planograms/{planogram_id}/labels/{label_uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Planogram Images
 */
export const mvpApiListPlanogramImages = <ThrowOnError extends boolean = false>(options: Options<MvpApiListPlanogramImagesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiListPlanogramImagesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/planograms/{planogram_id}/images',
        ...options
    });
};

/**
 * Create Planogram Images
 */
export const mvpApiCreatePlanogramImages = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreatePlanogramImagesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreatePlanogramImagesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/planograms/{planogram_id}/images',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Planogram Image
 */
export const mvpApiGetPlanogramImage = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetPlanogramImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetPlanogramImageResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/planograms/{planogram_id}/images/{label_uuid}',
        ...options
    });
};

/**
 * Get Stores Inventory
 */
export const mvpApiGetStoresInventory = <ThrowOnError extends boolean = false>(options?: Options<MvpApiGetStoresInventoryData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiGetStoresInventoryResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/inventory/stores',
        ...options
    });
};

/**
 * Get Devices Inventory
 */
export const mvpApiGetDevicesInventory = <ThrowOnError extends boolean = false>(options?: Options<MvpApiGetDevicesInventoryData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiGetDevicesInventoryResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/inventory/devices',
        ...options
    });
};